import sha256 from 'crypto-js/sha256';
import PreviewStore from '.';
import LearningDesignExperienceStore from '../../../../Experience/Store';
import { FormTemplate } from '../../../../../../../Resource/FormTemplates/Types';

export const setState = (initialFormHash: string): State => ({
  inEditMode: false,
  initialFormHash,
});

export const updateInitialFormHash = (state: State, initialFormHash: string): State => ({
  ...state,
  initialFormHash,
});

export const enterEditMode = (state: State): State => ({
  ...state,
  inEditMode: true,
});

export const leaveEditMode = (state: State): State => ({
  ...state,
  inEditMode: false,
});

export const isInEditMode = (store: PreviewStore) => store.inEditMode;

export interface State {
  inEditMode: boolean;
  initialFormHash: string;
}

export const shaHashGenerator = (
  items: Array<FormTemplate | readonly LearningDesignExperienceStore[]>,
): string => sha256(JSON.stringify(items)).toString();
